import { createSlice } from "@reduxjs/toolkit";
import {
  getAllActiveExperiences,
  getExperienceByURL,
} from "@/services/experience.services";

interface ExperienceState {
  loading: boolean;
  error: string;
  ExperienceList: unknown[];
  ExperienceDetails: Record<string, unknown>;
}

const initialState: ExperienceState = {
  loading: false,
  error: "",
  ExperienceList: [],
  ExperienceDetails: {},
};

const experienceSlice = createSlice({
  name: "experience",
  initialState,
  reducers: {
    clearExperienceDetails: (state) => {
      state.ExperienceDetails = initialState.ExperienceDetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllActiveExperiences.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveExperiences.fulfilled, (state, action) => {
      state.loading = false;
      state.ExperienceList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveExperiences.rejected, (state, action) => {
      state.loading = false;
      state.ExperienceList = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getExperienceByURL.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getExperienceByURL.fulfilled, (state, action) => {
      state.loading = false;
      state.ExperienceDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getExperienceByURL.rejected, (state, action) => {
      state.loading = false;
      state.ExperienceDetails = initialState.ExperienceDetails;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default experienceSlice.reducer;
export const { clearExperienceDetails } = experienceSlice.actions;
